import React, {Component} from 'react';
import RiotBar from '@riotgames/riotbar-react';

import './Footer.scss';

class Footer extends Component {
  render() {
    return (
      <div id="footer">
        <div id="riorbar-footer-container" />
        <RiotBar product={`${RIOTBAR_PRODUCT}`} environment={`${RIOTBAR_ENV}`} locale="ko_KR" />
        <div className="version">v${VERSION}</div>
      </div>
    );
  }
}

export default Footer;
